<template>
  <!-- NOTE: DOM上の改行と空白もレンダリングしてしまうため、このファイルではそのeslintルールを除外している -->
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <!-- eslint-disable prettier/prettier -->
  <div
    class="recommend-url-bulk-order-modal__cover"
    @click.self="onClickModalCover"
  >
    <div class="recommend-url-bulk-order-modal__content">
      <div class="recommend-url-bulk-order-modal__header">
        <CloseCircleOutline
          class="recommend-url-bulk-order-modal__close-icon"
          @click="onClickCloseButton"
        />
        <span>{{ title }}</span>
      </div>
      <div class="recommend-url-bulk-order-modal__body">
        <div class="recommend-url-bulk-order-modal__title-area">
          <ImgLazy
            :image-url="bulkOrderSuggestImagePath"
            aspect-ratio="8 / 5"
            class="recommend-url-bulk-order-modal__title-image"
          />
          <p class="recommend-url-bulk-order-modal__heading">
            まとめてオーダーは、<br />複数のギフトカードをまとめて購入できる<br />サービスです。
          </p>
        </div>
        <div>
          <p class="recommend-url-bulk-order-modal__main-text">
            複数人にギフトカードを配りたいとき、通常はgiftee上で1件ずつご購入いただく必要があります。
          </p>
          <p class="recommend-url-bulk-order-modal__main-text">
            「まとめてオーダー」では、<span class="recommend-url-bulk-order-modal__bold">複数のギフトカードを1度にまとめて購入</span>でき、ギフトカードURLはCSVファイルにまとめて納品いたします。
          </p>
        </div>
        <div class="recommend-url-bulk-order-modal__sample-csv-image-area p-8">
          <ImgLazy
            :image-url="sampleCsvImagePath"
            aspect-ratio="1116 / 331"
            class="recommend-url-bulk-order-modal__sample-csv-image"
          />
          <p class="recommend-url-bulk-order-modal__sub-text">納品CSVイメージ</p>
        </div>
        <div class="recommend-url-bulk-order-modal__notice-area p-8">
          <p class="recommend-url-bulk-order-modal__caption-primary">
            ご利用の際は以下にご注意ください。
          </p>
          <ul class="recommend-url-bulk-order-modal__list">
            <li>ギフトカードの合計が<span class="recommend-url-bulk-order-modal__bold">11件以上</span>からお申し込み受付。</li>
            <li>お支払い方法は<span class="recommend-url-bulk-order-modal__bold">銀行振り込み</span>のみ。</li>
            <li><span class="recommend-url-bulk-order-modal__bold">個人名義の口座</span>からのお振り込みのみ可能。</li>
            <li>発行したギフトカードURLは、<span class="recommend-url-bulk-order-modal__bold">CSVファイルをメールに添付</span>して納品。</li>
          </ul>
        </div>
        <div class="recommend-url-bulk-order-modal__btn--link">
          <a href="/announcements/69" @click="onClickBulkUrlLp">詳しい情報はこちら</a>
        </div>
      </div>
      <div class="recommend-url-bulk-order-modal__footer">
        <div class="recommend-url-bulk-order-modal__btn-area">
          <ButtonPrimary
            text="まとめてオーダーを利用する"
            @click-primary-button="onClickBulkOrder"
          />
          <p class="recommend-url-bulk-order-modal__sub-text">
            現在選択中のギフトがある場合、内容は引き継がれず、<br />新たにまとめてオーダーの申し込み画面へ移動します。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseCircleOutline from '../../atoms/svg_icons/CloseCircleOutline.vue'
import BulkOrderSuggest from '../../../../../images/personal-bulk-order-suggest.png'
import ButtonPrimary from '../../molecules/buttons/ButtonPrimary.vue'
import SampleCsv from '../../../../../images/personal-bulk-order-sample-csv.png'
import ImgLazy from '../../atoms/images/ImgLazy.vue'

export default {
  components: {
    CloseCircleOutline,
    ButtonPrimary,
    ImgLazy
  },
  props: {
    fulfillment: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    title() {
      return this.fulfillment
        ? 'まとめてオーダー(URL形式)とは？'
        : 'まとめてオーダーとは？'
    },
    bulkOrderSuggestImagePath() {
      return BulkOrderSuggest
    },
    sampleCsvImagePath() {
      return SampleCsv
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    },
    onClickBulkUrlLp() {
      dataLayer.push({
        event: 'click_bulk_detail_modal__bulk_url_lp',
        via: 'item_detail'
      })
    },
    onClickBulkOrder() {
      dataLayer.push({
        event: 'click_bulk_detail_modal__url_form',
        via: 'item_detail'
      })
      window.location.href = '/bulk_order/gift_cards'
    }
  }
}
</script>
<style lang="scss" scoped>
.recommend-url-bulk-order-modal {
  &__cover {
    // TODO: z-index 全体を管理する際に適切なファイル、値にする
    // header が 100 なので 101 をセットする
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 92%;
    padding: 0 4%;
    background-color: $dark_black_cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  &__content {
    background: $white;
    border-radius: 8px;
    text-align: center;
    width: 100%;
    max-width: 343px;
    max-height: 90%;
    margin: auto 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    // 横幅が375px以下の場合、モーダル横の余白を確保するために横幅を300pxにする
    @media screen and (max-width: $small-contents-width) {
      width: 300px;
    }
  }

  &__header {
    @extend %body-bold;
    padding: 24px 24px 16px 24px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: solid $gray-1 1px;

    @media screen and (max-width: $small-contents-width) {
      padding-left: 4.3%;
      padding-right: 4.3%;
    }
  }

  &__body {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    // 65px: headerの高さ, 124px: footerの高さ
    max-height: calc(100% - 65px - 124px);
  }

  &__footer {
    padding: 16px 24px 24px;
  }

  &__title-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
  }

  &__notice-area {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
    width: 100%;
    box-sizing: border-box;
    background-color: $gray-3;
    border-radius: 4px;
  }

  &__sample-csv-image-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
    box-sizing: border-box;
    background-color: $gray-3;
    border-radius: 4px;
  }

  &__btn-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
  }

  &__heading {
    @extend %body-bold;
    color: $black;
    text-align: center;
  }

  &__caption-primary {
    @extend %caption-bold;
    color: $primary;
    text-align: left;
  }

  &__main-text {
    @extend %caption;
    color: $black;
    text-align: left;
  }

  &__title-image {
    width: 120px;
    object-fit: contain;
  }

  &__sample-csv-image {
    width: 100%;
    object-fit: contain;
  }

  &__sub-text {
    @extend %minimal;
    color: $gray-1;
    text-align: left;
  }

  &__list {
    @extend %caption-black;
    padding-left: 6px;

    li {
      list-style: inside;
    }
  }

  &__btn {
    &--link {
      font-size: 1.2rem;
      line-height: 1.6;

      a {
        color: $link;
        margin: auto;
        cursor: pointer;
      }
    }
  }

  &__bold {
    font-weight: bold;
  }
}
</style>
